import { PageHeader } from "../components/Layout";
import WheelView from "../components/WheelView";

export default function DefenseWheel() {
  return (
    <div className="p-5 md:p-8 max-w-7xl mx-auto">
      <PageHeader title="Ruota Difesa" subtitle="Estrai un operatore di difesa. Gestione indipendente dall'attacco." accent="orange" />
      <WheelView slug="defense" accentType="defense" />
    </div>
  );
}
